import React, { useEffect, useRef } from "react";
import "./App.css";
import useStore from "./store.js";
import { socket } from "./socket";

import { Routes, Route, useParams, useLocation } from "react-router-dom";

import Button from "./components/Button/Button.js";
import PageStart from "./Pages/PageStart.js";
import TestPage from "./Pages/PageTemplate.js";
import PageCharacters from "./Pages/PageCharacters.js";
import PageCharacter from "./Pages/PageCharacter.js";
import PageVerkleidung from "./Pages/PageVerkleidung.js";
import PageIntro from "./Pages/PageIntro.js";
import PageStory from "./Pages/PageStory.js";
import PageRound from "./Pages/PageRound.js";
import PageHint from "./Pages/PageHint.js";
import PageHints from "./Pages/PageHints.js";
import PageRules from "./Pages/PageRules.js";
import PageAblauf from "./Pages/PageAblauf.js";
import PageReveal from "./Pages/PageReveal.js";
import PageOutro from "./Pages/PageOutro.js";
import PageDownloads from "./Pages/PageDownloads.js";
import PageSessionNotFound from "./Pages/PageSessionNotFound.js";

import { useNavigateWithVars } from "./hooks/useNavigateWithVars";
import Header from "./components/Header/Header.js";
import SideMenu from "./components/SideMenu/SideMenu.js";
import PopupBildButton from "./components/PopupBildButton/PopupBildButton.js";
import PopupBildOverlay from "./components/PopupBildOverlay/PopupBildOverlay.js";
import APIRequestDemo from "./APIDummy.js";

function App() {
  const location = useLocation();
  const setUid = useStore((state) => state.setUid);
  const uid = useStore((state) => state.uid);
  const fetchSession = useStore((state) => state.fetchSession);
  const setSessionData = useStore((state) => state.setSessionData);
  const sessionData = useStore((state) => state.sessionData);
  const sessionNotFound = useStore((state) => state.sessionNotFound);
  const game = useStore((state) => state.game);
  const texts = useStore((state) => state.texts);
  const fetchTexts = useStore((state) => state.fetchTexts);

  const gameState = useStore((state) => state.gameState);
  const setGameState = useStore((state) => state.setGameState);
  const character = useStore((state) => state.character);
  // const setCharacter = useStore((state) => state.setCharacter);
  const fetchCharacter = useStore((state) => state.fetchCharacter);
  const isHost = useStore((state) => state.isHost);
  const currentHint = useStore((state) => state.currentHint);
  const activateHintTooltip = useStore((state) => state.activateHintTooltip);
  const setSessionHint = useStore((state) => state.setSessionHint);

  const popupBildOpen = useStore((state) => state.popupBildOpen);
  const currentPopupBild = useStore((state) => state.currentPopupBild);
  const openPopupBild = useStore((state) => state.openPopupBild);
  const closePopupBild = useStore((state) => state.closePopupBild);
  const setHasPopupBild = useStore((state) => state.setHasPopupBild);

  // Check if we're on a round page
  const isRoundPage = location.pathname.startsWith("/round/");

  // Track previous hint value to detect actual changes
  const previousHintRef = useRef(currentHint);

  // const startGameSession = useStore((state) => state.startGameSession);
  const checkAllCharactersCheckedIn = useStore(
    (state) => state.checkAllCharactersCheckedIn,
  );

  const lang = useStore((state) => state.lang);

  const fetchAll = useStore((state) => state.fetchAll);

  // const hint = useStore((state) => state.hint);

  const navigateTo = useNavigateWithVars();

  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    let theCharacterId = queryParameters.get("c");

    if (!theCharacterId && isHost) {
      theCharacterId = sessionData?.hostcharacteruid;
    }

    if (theCharacterId) {
      if (game?.Characters?.data) {
        console.log("game", game, theCharacterId);
        const found = game.Characters.data.find(
          (c) => c.attributes.uid === theCharacterId,
        );
        console.log("found", found);
        //setCharacter(found);
        if (found) {
          fetchCharacter(found.id);
        }
      }
    }
  }, [game]);

  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    const theUid = queryParameters.get("uid");

    console.log("uid", theUid, "c");

    setUid(theUid);

    fetchTexts();

    function onConnect(event) {
      console.log("connected");
    }

    function onDisconnect() {
      console.log("disconnected");
    }

    function onSessionEvent(value) {
      console.log("session", value, value.data.attributes.uid, theUid);
      if (value?.data?.attributes?.uid === theUid) {
        const newHintOpened = value.data.attributes.HintOpened;
        console.log(
          "session changed!",
          theUid,
          "newHintOpened:",
          newHintOpened,
          "previousHint:",
          previousHintRef.current,
        );
        setSessionData(value.data.id, value.data.attributes);
        fetchSession(theUid);

        // Only activate tooltip if hint actually changed (increased)
        if (newHintOpened != null && newHintOpened > previousHintRef.current) {
          console.log("Hint changed from", previousHintRef.current, "to", newHintOpened);
          activateHintTooltip(newHintOpened);
          previousHintRef.current = newHintOpened;
        }
      }
    }

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("session:update", onSessionEvent);
    // socket.onAny((event, ...args) => {
    //   console.log("Any", event, args);
    // });

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("session:update", onSessionEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log("gameState", gameState, currentHint);
    if (gameState === -1) {
      console.log("Game not started", character, uid);
      if (uid) {
        if (character) navigateTo(`/character/`);
        else navigateTo(`/`);
      }
    } else if (gameState === 0) {
      console.log("Game Started");
      // if (!sessionData?.started) startGameSession();
      if (isHost) navigateTo(`/intro/`);
    } else if (gameState > 0 && gameState <= game?.Rounds) {
      console.log("Round ", gameState, currentHint);
      navigateTo(`/round/${gameState}`);
    } else if (gameState > game?.Rounds) {
      console.log("Auflösung!", gameState, currentHint);
      navigateTo(`/reveal/`);
    } else {
      console.log("Game State", gameState);
      navigateTo(`/`);
    }
  }, [gameState]);

  // const renderPages = () => {
  //   console.log("gameState", gameState);
  //   switch (gameState) {
  //     case -1:
  //       return <PageStart />;
  //     default:
  //       return <TestPage />;
  //   }
  // };

  useEffect(() => {
    if (uid) {
      console.log("set uid", uid);
      fetchSession(uid);
    } else if (uid === null) {
      // No uid parameter in URL - this is also a "not found" scenario
      // (except for /create-session/ route which we'll handle separately)
      const path = window.location.pathname;
      if (path !== '/create-session/' && path !== '/create-session') {
        // Mark as not found after texts are loaded
        if (texts) {
          useStore.setState({ sessionNotFound: true });
        }
      }
    }
  }, [uid, texts, fetchSession]);

  useEffect(() => {
    // Always check if characters are checked in when session data changes
    if (sessionData) checkAllCharactersCheckedIn();
  }, [sessionData]);

  // Update the ref whenever currentHint changes from the store
  useEffect(() => {
    previousHintRef.current = currentHint;
  }, [currentHint]);

  // Scroll to top whenever the page/route changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Apply CSS variables to document body for global background
  useEffect(() => {
    if (game) {
      document.body.style.setProperty(
        "--game-color",
        game.GameColor || "hotpink",
      );
      document.body.style.setProperty(
        "--main-background",
        game.MainBackground || "white",
      );
      document.body.style.setProperty(
        "--start-background",
        game.StartBackground || "#121212",
      );
      document.body.style.backgroundColor = game.StartBackground || "#121212";

      // Check if game has ZusatzInfoBilder components
      setHasPopupBild(
        game.ZusatzInfoBilder && game.ZusatzInfoBilder.length > 0,
      );
    }
  }, [game, setHasPopupBild]);

  // Show error page if session was not found
  if (sessionNotFound && texts) {
    return (
      <div className="App">
        <PageSessionNotFound />
      </div>
    );
  }

  if (!game || !texts)
    return (
      <Routes>
        <Route path="/" element={null} />
        <Route path="/create-session/" element={<APIRequestDemo />} />
      </Routes>
    );

  if (sessionData?.ended)
    return (
      <div
        className="App"
        style={{
          ["--game-color"]: game ? game.GameColor : "",
          ["--main-background"]: game ? game.MainBackground : "",
          ["--start-background"]: game ? game.StartBackground : "",
        }}
      >
        <PageStart />
      </div>
    );

  return (
    <div
      className="App"
      style={{
        ["--game-color"]: game ? game.GameColor : "",
        ["--main-background"]: game ? game.MainBackground : "",
        ["--start-background"]: game ? game.StartBackground : "",
      }}
    >
      <SideMenu />
      {/* {renderPages()} */}
      <Routes>
        <Route path="/" element={<PageStart />} />
        <Route path="/characters/" element={<PageCharacters />} />
        <Route path="/character/" element={<PageCharacter />} />
        <Route path="/verkleidung/" element={<PageVerkleidung />} />
        <Route path="/intro/" element={<PageIntro />} />
        <Route path="/story/" element={<PageStory />} />
        <Route path="/rules/" element={<PageRules />} />
        <Route path="/ablauf/" element={<PageAblauf />} />
        <Route path="/round/:roundid" element={<PageRound />} />

        <Route path="/hint/:hintid" element={<PageHint />} />
        <Route path="/hints/" element={<PageHints />} />
        <Route path="/reveal/" element={<PageReveal />} />
        <Route path="/outro/" element={<PageOutro />} />

        <Route path="/downloads/" element={<PageDownloads />} />

        <Route path="/create-session/" element={<APIRequestDemo />} />
      </Routes>
      <Header />

      {/* PopupBild Buttons - shown only on round pages when game has ZusatzInfoBilder components */}
      {isRoundPage &&
        game?.ZusatzInfoBilder &&
        game.ZusatzInfoBilder.length > 0 && (
          <div className="PopupBildButtonContainer">
            {game.ZusatzInfoBilder.map((zusatzInfo, index) => (
              <PopupBildButton
                key={index}
                label={zusatzInfo.Titel}
                onClick={() => {
                  const imageUrl = `${process.env.REACT_APP_CMS_URL}${zusatzInfo.Bild.data.attributes.url}`;
                  openPopupBild({ imageUrl, title: zusatzInfo.Titel });
                }}
              />
            ))}
          </div>
        )}

      {/* PopupBild Overlay */}
      {popupBildOpen && currentPopupBild && (
        <PopupBildOverlay
          imageUrl={currentPopupBild.imageUrl}
          onClose={closePopupBild}
        />
      )}

      <>
        {false && isHost && (
          <div className="debug">
            <button onClick={() => setGameState(gameState - 1)}>-1</button>
            <button onClick={() => setGameState(gameState + 1)}>+1</button>
            <button onClick={() => setSessionHint(-1)}>Reset Hints</button>
            <h1>Session Data</h1>
            <pre>{JSON.stringify(sessionData, null, 2)}</pre>
          </div>
        )}
      </>
    </div>
  );
}

export default App;
